import { STATUS, USER_ROLES } from "./constants";

export const GRUPOS = Object.freeze({
  OISOL_MASTER: "OISOL_MASTER",
});

const ALIAS_OISOL_MASTER = ["OISOL_MASTER", "OISOL.MASTER", "OISOL MASTER"];

function normalizarGrupo(valor) {
  if (typeof valor !== "string") return "";
  return valor.trim().toUpperCase().replace(/[.\s]/g, "_");
}

function extrairNomesGrupo(user) {
  const valores = []
    .concat(user?.grupos || [])
    .concat(user?.groups || [])
    .concat(user?.grupo || [])
    .filter(Boolean);

  return valores
    .map((item) => {
      if (typeof item === "string") return item;
      return item?.nome || item?.name || item?.group || item?.grupo || null;
    })
    .filter(Boolean);
}

export function isOisolMaster(user) {
  if (!user) return false;
  return extrairNomesGrupo(user).some((nome) =>
    ALIAS_OISOL_MASTER.map(normalizarGrupo).includes(normalizarGrupo(nome))
  );
}

export function podeGerenciarIntegracaoDenuncia(user) {
  return isOisolMaster(user);
}

export function podeGerenciarMenuIndicador(user) {
  return isOisolMaster(user);
}

export function podeGerenciarMensagensGlobais(user) {
  return isOisolMaster(user);
}

function autoridades(user) {
  return Array.isArray(user?.authorities) ? user.authorities : [];
}

export function temChatMaster(user) {
  return autoridades(user).includes(USER_ROLES.CHAT_MASTER);
}

export function podeUsarChat(user) {
  const lista = autoridades(user);
  return lista.includes(USER_ROLES.CHAT_MASTER) || lista.includes(USER_ROLES.CHAT_PADRAO);
}

export function podeConsultarUsuariosLogados(user) {
  return autoridades(user).includes(USER_ROLES.USUARIOS_LOGADOS_CONSULTAR);
}

export function podeEncerrarSessoesUsuarios(user) {
  return autoridades(user).includes(USER_ROLES.USUARIOS_LOGADOS_ENCERRAR);
}

export function podeArquivarDenunciaPorStatus(user, statusDescricao) {
  const lista = autoridades(user);
  if (!lista.includes(USER_ROLES.ARQUIVAR_DENUNCIA)) {
    return false;
  }
  if (statusDescricao === STATUS.ARQUIVADA) {
    return false;
  }
  if (lista.includes(USER_ROLES.ARQUIVAR_DENUNCIA_QUALQUER_STATUS)) {
    return true;
  }
  return statusDescricao === STATUS.ANALISAR;
}
